import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import api from '@/api.js';
import * as OpenCC from 'opencc-js';
import { ref } from 'vue';
import Swal from 'sweetalert2';
const converter = OpenCC.Converter({ from: 'cn', to: 'tw' });
export function useAll() {
  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const isPlaying = ref(false);

  const getTTSUrl = (gender, result) => {
    let path = `/ai/tts`;
    if (route.name === 'ChatAIJp') {
      path += `/?lang=ja-JP`
    } else if (route.name === 'ChatAIFr') {
      path += `/?lang=fr-FR`
    } else {
      path += `/?lang=${store.state.selectedAccent}`
    }

    return api
      .post(path, { text: result, gender: gender || 'female', kid: false })
      .then((res) => res.data.url)
      .catch(() => '');
  };

  const get_Translate_Dialog = (theme, context, result) => {
    let path = `/ai/generate/15044d0c-2c65-4e1c-81bd-b57f0983686e`;
    if (route.name === 'ChatAIJp') {
      path = `/ai/generate/d4e0a2ad-0a5a-49dc-aaef-11f370b31462`
    }
    if (route.name === 'ChatAIFr') {
      path = `/ai/generate/19a48719-5e17-48a9-8d4d-56acca96d39d`
    }
    return api
      .post(path, {
        content: result,
        theme: theme,
        context: context
      })
      .then((res) => converter(res.data.result))
      .catch(() => {});
  };

  const getTranslateSpeech = (result) => {
    const path = `/ai/generate/e3714685-1955-4f85-bc73-5652ff3fc80d`;

    return api
      .post(path, { content: result })
      .then((res) => converter(res.data.result))
      .catch(() => {});
  };

  const playAudioStandard = (dynamicId) => {
    const audioPlayer = document.querySelector(`#playBtn${dynamicId}`);
    if (audioPlayer) {
      audioPlayer.onplaying = () => (isPlaying.value = true);
      audioPlayer.onpause = () => (isPlaying.value = false);

      if (isPlaying.value) {
        audioPlayer.pause();
        audioPlayer.currentTime = 0;
        isPlaying.value = false;
      } else {
        audioPlayer.play();
        isPlaying.value = true;
      }
    }
  };

  const copyTextSelection = (text) => {
    navigator.clipboard.writeText(text).catch(() => {});
  };

  const objIsEmpty = (obj) => !obj || Object.keys(obj).length === 0;

  const isNotEmpty = (array) => array.every((obj) => Object.keys(obj).length !== 0);

  const generateCheck = () =>
    Swal.fire({
      title: '提醒',
      html: `目前總點數：<span class="gept_main_color9">${100}</span> 點<br/>每次交卷看報告隨即扣除 1 點。`,
      showCloseButton: true,
      confirmButtonText: `我知道了`,
      customClass: {
        popup: 'p-0',
        htmlContainer: 'p-4 font-bold leading-loose',
        confirmButton: 'denyButton-gept',
      },
    }).then((result) => result.isConfirmed);

  const getDeductionPoint = () => {
    const points = Number(localStorage.getItem('RD_p'));
    return Number.isFinite(points) && points > 0 ? points : 10;
  };

  const getDeductionUnit = () => {
    const unitMap = { p: '點', t: '次', n: null };
    return unitMap[localStorage.getItem('RD_pu')] ?? '點';
  };

  const deductionPoints = (level, unit) => {
    const pointsMap = {
      '初級': {
        '單句寫作': 30,
        '段落寫作': 20,
        '朗讀句子與短文': 10,
        '複誦': 10,
        '回答問題': 20
      },
      '中級': {
        '中譯英': 30,
        '英文作文': 30,
        '朗讀短文': 20,
        '回答問題': 30,
        '看圖敘述': 30
      }
    };

    return pointsMap[level]?.[unit] ?? getDeductionPoint();
  };

  const checkSubmitReport = (pName, pType) => {
    const deductionUnit = getDeductionUnit();
    const deductionPoint = getDeductionPoint();
    let html = `
      <p class="gept_main_color4 text-2xl mb-4">確認送出 ${pName} ${pType} 練習？</p>
      <p class="text-left mb-2">按下確認後，AI 將開始批改並產生報告。</p>
    `;

    if (deductionUnit) {
      html += `
        <p class="text-left mb-1">目前總${deductionUnit}數：${store.state.remainPoints} ${deductionUnit}</p>
        <p class="text-left mb-1">需扣除：${deductionPoint} ${deductionUnit}</p>
        <p class="text-left">扣除後${deductionUnit}數：${store.state.remainPoints - deductionPoint}</p>
      `;
    }

    return Swal.fire({
      html,
      showDenyButton: true,
      focusConfirm: false,
      confirmButtonText: '確認',
      denyButtonText: '返回',
      customClass: {
        popup: 'p-4',
        header: 'p-0',
        htmlContainer: 'remainPoints_swal my-4 text-left',
        actions: 'mb-4 mt-2',
        confirmButton: 'submitButton-gept order-2',
        denyButton: 'denyButton-gept order-1'
      }
    }).then((result) => result.isConfirmed === true);
  };

  const post_records_by_AIETA = (exam_id, id, part, text, file) => {
    const path = `/toeic/exams/${exam_id}/records`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('id', id);
    formData.append('part', part);
    formData.append('text', text);

    return api.post(path, formData, {
      timeout: 30000,
      headers: {
        "Content-Type": "multipart/form-data",
      }
    })
      .then((response) => response.data);
  };

  const finish_exams = async (exam_id, part, isGuideLink, seconds) => {
    const maxRetries = 10;
    const retryInterval = 10000;
    const path = `/toeic/exams/${exam_id}/finish`;

    store.dispatch('isLoading', true);

    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        const response = await api.post(path, { part });
        const recordId = response.data.record_id;
        store.dispatch('isLoading', false);

        if (isGuideLink) {
          const query = {};
          if (route.query.sid) query.sid = route.query.sid;

          router.push({
            name: 'gept_report_part',
            params: { select_id: route.params.select_id || exam_id, record_id: recordId },
            query
          });
        }

        const recordArray = {
          conversation_id: route.params.select_id || exam_id,
          sentence_sn: recordId,
          book: `GEPT ${store.state.level || ''}`.trim(),
          subject: part,
          unit: part,
          used_points: deductionPoints(store.state.level, part)
        };

        if (seconds !== undefined) {
          recordArray.seconds = seconds;
        }

        store.dispatch('writeRecord', recordArray);
        if (store.getters.ai_sid) {
          store.dispatch('saveRecord', recordArray);
        }

        return response.data;
      } catch (err) {
        if (attempt === maxRetries - 1) {
          store.dispatch('isLoading', false);
          throw err;
        }

        await new Promise(resolve => setTimeout(resolve, retryInterval));
      }
    }
  };

  const finish_exams_writing = (exam_id, part, isGuideLink, seconds) => {
    return finish_exams(exam_id, part, isGuideLink, seconds);
  };

  const getItemRecords = (id, item_id) => {
    if (!id || !item_id) return
    let path = `/books/${id}/items/${item_id}`

    return api
      .get(path)
      .then((res) => res.data)
      .catch((error) => {
        console.log(error.response.data.error)
        router.push({ name: 'myList' })
        Swal.fire({
          title: '提醒',
          html: `${error.response.data.error}`,
          showCloseButton: true,
          confirmButtonText: `我知道了`,
          customClass: {
            popup: 'p-0',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit ai_bg_05',
            title: 'ai_bg_03 text-white text-lg py-4'
          },
        }).then((result) => result.isConfirmed);
      })
  }

  const postItemRecords = (id, item_id, text) => {
    let path = `/books/${id}/items/${item_id}/record`;
    const formData = new FormData();
    formData.append('text', text);

    return api
      .post(path, formData)
      .then(() => getItemRecords(id, item_id))
      .catch(() => {});
  };

  const infoFunc = () => {
    Swal.fire({
      html: `<h6 class="mb-3 ai_text_06 text-xl">全新AI學習網上線了</h6>
      <div class="flex justify-center">
        <ul class="text-left list-decimal leading-relaxed text-lg">
          <li>第一次使用請先註冊並登入LiveABC會員。</li>
          <li>於輸入雜誌最後一頁之序號或書籍之數位產品序號卡進行兌換。</li>
          <li>相關使用規範請參照各書後方注意事項。</li>
          <li>請使用Chrome或Safari輸入網址https://elearning.liveabc.com使用本網站服務。</li>
        </ul>
      </div>
`,
      showCloseButton: false,
      focusConfirm: false,
      confirmButtonText: `確認`,
      title: '使用說明',
      customClass: {
        title: 'text-white text-2xl ai_bg_01 font-semibold pb-4',
        container: '',
        popup: 'p-0',
        header: 'swal-header-notice justify-center items-center',
        closeButton: '',
        htmlContainer: 'my-3 font-semibold px-12',
        actions: 'mb-4 mt-2',
        confirmButton: 'ai_bg_01 px-36',
        cancelButton: 'bg-red-main-ai',
      }
    })
  }

  return {
    getTTSUrl,
    get_Translate_Dialog,
    getTranslateSpeech,
    playAudioStandard,
    copyTextSelection,
    objIsEmpty,
    isNotEmpty,
    generateCheck,
    checkSubmitReport,
    post_records_by_AIETA,
    finish_exams,
    finish_exams_writing,
    deductionPoints,
    isPlaying,
    getItemRecords,
    postItemRecords,
    infoFunc
  };
}
